const testimonials = [
  {
    id: 1,
    name: "Shaif Arfan",
    title: "CEO",
    org: "WEB CIFAR",
    desc: "Ajibade is a person of commitment. He is really good at what he does. I reall like his work. Especially very detailed with web security",
  },
  {
    id: 2,
    name: "Pete",
    title: "UI/UX Designer",
    org: "Freelancer",
    desc: "Great guy Nice work ethic.",
  },
];

export default testimonials;
